<template>
  <div>
    <div style="text-align: center" v-if="!itmes || itmes.length === 0">
      <img src="/image/static/img/nodata.png" />
      <p class="no-data">此运单暂无状态更新！</p>
    </div>
    <el-timeline>
      <el-timeline-item
        v-for="(itme, index) in itmes"
        :key="index"
        type="primary"
        placement="top"
        :timestamp="'更新时间：' + itme.modifyTime"
      >
        <div class="p-2">
          <p>
            运输状态：<el-tag v-if="itme.transStatus">{{
              itme.transStatus
            }}</el-tag>
          </p>
          <p>
            运输状态说明：<el-tag type="info" v-if="itme.transRemark">
              {{ itme.transRemark }}</el-tag
            >
          </p>
          <p>
            上报地点经度：<el-tag v-if="itme.transLongitude">{{
              itme.transLongitude
            }}</el-tag>
          </p>
          <p>
            上报地点纬度：<el-tag v-if="itme.transLatitude">{{
              itme.transLatitude
            }}</el-tag>
          </p>
          <p>
            上报终端：<el-tag v-if="itme.upClientName">{{
              itme.upClientName
            }}</el-tag>
          </p>
          <p>
            车牌号：<el-tag type="info" v-if="itme.vehicleNo">{{
              itme.vehicleNo
            }}</el-tag>
          </p>
          <p>
            司机姓名：<el-tag type="info" v-if="itme.driverName">{{
              itme.driverName
            }}</el-tag>
          </p>
          <p>
            有效状态：<el-tag
              v-if="itme.wayBillLogStatusName"
              :type="itme.wayBillLogStatus === 'Y' ? 'success' : 'danger'"
              >{{ itme.wayBillLogStatusName }}</el-tag
            >
          </p>
        </div>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>
<script>
export default {
  props: {
    code: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      itmes: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      return this.$api
        .carriageWaybillLogListApi({ waybillCode: this.code })
        .then((res) => {
          this.itmes = res.body.data
        })
    },
  },
}
</script>
